module.exports = __webpack_public_path__ + "img/general-conditions-pt.1b4c8f3e.png";